import { useEffect } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
const Privacy = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      <div className="px-5 md:px-0 md:mx-24 sm:mx-12">
        <div className="grid grid-cols-12 gap-5 mb-20 mt-20">
          {/* Main Content */}
          <div className="col-span-12 md:col-span-9 order-last md:order-first">
            <h1 className="text-5xl sm:text-5xl md:text-6xl lg:text-[64px] mb-7 font-extrabold">
              Privacy Policy
            </h1>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-3">
              Last Updated: May 6, 2025
            </p>
            <p
              className="text-base sm:text-lg 2xl:text-2xl mb-6"
              style={{ lineHeight: "1.5" }}
            >
              This Privacy Policy explains how we collect, use, and protect your
              personal information when you use our websites, mobile
              applications, and related services under FastBetter.com
              (collectively, the “Services”).
            </p>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              By using our Services, you consent to this Privacy Policy.
            </p>

            <h3 className="font-bold text-[32px] pt-6 mb-3" id="who-we-are">
              1. Who We Are
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              We are FastBetter, based in Cyprus, delivering health and wellness
              solutions through digital products. For GDPR purposes, we are the
              “data controller.”
            </p>
            <ul className="list-disc pl-6 text-base sm:text-lg 2xl:text-2xl mb-6">
              <li>
                Email:{" "}
                <a
                  href="mailto:support@fastbetter.com"
                  className="text-blue-600 underline"
                >
                  support@fastbetter.com
                </a>
              </li>
              <li>
                Legal inquiries:{" "}
                <a
                  href="mailto:legal@fastbetter.com"
                  className="text-blue-600 underline"
                >
                  legal@fastbetter.com
                </a>
              </li>
            </ul>

            <h3
              className="font-bold text-[32px] pt-6 mb-3"
              id="data-we-collect"
            >
              2. What Data We Collect
            </h3>
            <ul className="list-disc pl-6 text-base sm:text-lg 2xl:text-2xl mb-6">
              <li>
                <b>Personal Data:</b> Name, email address, password, age,
                gender, country, payment info (via Stripe, Apple/Google), device
                identifiers (IP, device ID)
              </li>
              <li>
                <b>Health & Wellness Data:</b> Fasting logs, goals, hydration,
                weight, yoga progress, flexibility, injury reports, Apple
                HealthKit or Google Fit integration (optional)
              </li>
              <li>
                <b>Usage & Analytics:</b> Firebase Analytics, crash logs,
                cookies, and similar tech
              </li>
            </ul>

            <h3 className="font-bold text-[32px] pt-6 mb-3" id="legal-basis">
              3. Legal Basis for Processing (GDPR)
            </h3>
            <ul className="list-disc pl-6 text-base sm:text-lg 2xl:text-2xl mb-6">
              <li>Consent (e.g., for health tracking)</li>
              <li>Contractual necessity (e.g., subscriptions)</li>
              <li>Legal obligations (e.g., financial regulations)</li>
              <li>Legitimate interests (e.g., analytics, improvement)</li>
            </ul>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              Health data is only processed with explicit consent under Article
              9(2)(a) of GDPR.
            </p>

            <h3 className="font-bold text-[32px] pt-6 mb-3" id="how-we-use">
              4. How We Use Your Data
            </h3>
            <ul className="list-disc pl-6 text-base sm:text-lg 2xl:text-2xl mb-6">
              <li>To operate and improve the Services</li>
              <li>To personalize your experience</li>
              <li>To manage subscriptions and payments</li>
              <li>To communicate updates/offers (you may opt out)</li>
              <li>To secure the app and prevent misuse</li>
              <li>To monitor crashes and resolve bugs</li>
            </ul>

            <h3 className="font-bold text-[32px] pt-6 mb-3" id="sharing">
              5. How We Share Your Data
            </h3>
            <ul className="list-disc pl-6 text-base sm:text-lg 2xl:text-2xl mb-6">
              <li>With payment processors (e.g., Stripe, Apple/Google)</li>
              <li>With analytics tools (e.g., Firebase)</li>
              <li>With cloud/hosting providers (e.g., AWS)</li>
              <li>With legal compliance services</li>
              <li>
                <b>We do not sell your personal data.</b>
              </li>
            </ul>

            <h3 className="font-bold text-[32px] pt-6 mb-3" id="healthkit">
              6. Apple HealthKit and Google Fit
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              If integrated, we only access data you approve. Used solely for
              fasting, tracking, and fitness insights. Not used for advertising.
            </p>

            <h3 className="font-bold text-[32px] pt-6 mb-3" id="retention">
              7. Data Retention
            </h3>
            <ul className="list-disc pl-6 text-base sm:text-lg 2xl:text-2xl mb-6">
              <li>As long as your account is active</li>
              <li>Up to 5 years for legal compliance</li>
              <li>You may request deletion at any time</li>
            </ul>

            <h3 className="font-bold text-[32px] pt-6 mb-3" id="international">
              8. International Transfers
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              If data is stored outside the EU, we use GDPR-approved safeguards
              like Standard Contractual Clauses (SCCs).
            </p>

            <h3 className="font-bold text-[32px] pt-6 mb-3" id="your-rights">
              9. Your Rights
            </h3>
            <ul className="list-disc pl-6 text-base sm:text-lg 2xl:text-2xl mb-6">
              <li>Access, correct, or delete your data</li>
              <li>Withdraw consent</li>
              <li>Object to or restrict processing</li>
              <li>Data portability</li>
              <li>File a complaint</li>
            </ul>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              Email{" "}
              <a
                href="mailto:privacy@fastbetter.com"
                className="text-blue-600 underline"
              >
                privacy@fastbetter.com
              </a>{" "}
              to exercise your rights.
            </p>

            <h3 className="font-bold text-[32px] pt-6 mb-3" id="children">
              10. Children’s Privacy
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              Our Services are not intended for users under 18. We delete any
              data unintentionally collected from children under 16.
            </p>

            <h3 className="font-bold text-[32px] pt-6 mb-3" id="cookies">
              11. Cookies
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl mb-6">
              We use cookies for session management, analytics, and
              personalization. You can manage cookies through your browser
              settings.
            </p>

            <h3 className="font-bold text-[32px] pt-6 mb-3" id="updates">
              12. Updates to This Policy
            </h3>
            <p className="text-base sm:text-lg 2xl:text-2xl">
              We may update this policy and notify users via email or in-app
              banner.
            </p>
          </div>

          {/* Sidebar Navigation */}
          <div className="col-span-12 md:col-span-3 leftboox md:sticky top-24 min-h-fit md:h-[475px] rounded-3xl bg-orgltbg">
            <div className="px-5 py-4 md:px-6 md:py-8">
              <ol className="litex space-y-2 pl-4">
                <li>
                  <a href="#who-we-are" className="hover:underline">
                    Who We Are
                  </a>
                </li>
                <li>
                  <a href="#data-we-collect" className="hover:underline">
                    What Data We Collect
                  </a>
                </li>
                <li>
                  <a href="#legal-basis" className="hover:underline">
                    Legal Basis for Processing
                  </a>
                </li>
                <li>
                  <a href="#how-we-use" className="hover:underline">
                    How We Use Your Data
                  </a>
                </li>
                <li>
                  <a href="#sharing" className="hover:underline">
                    How We Share Your Data
                  </a>
                </li>
                <li>
                  <a href="#healthkit" className="hover:underline">
                    Apple HealthKit & Google Fit
                  </a>
                </li>
                <li>
                  <a href="#retention" className="hover:underline">
                    Data Retention
                  </a>
                </li>
                <li>
                  <a href="#international" className="hover:underline">
                    International Transfers
                  </a>
                </li>
                <li>
                  <a href="#your-rights" className="hover:underline">
                    Your Rights
                  </a>
                </li>
                <li>
                  <a href="#children" className="hover:underline">
                    Children’s Privacy
                  </a>
                </li>
                <li>
                  <a href="#cookies" className="hover:underline">
                    Cookies
                  </a>
                </li>
                <li>
                  <a href="#updates" className="hover:underline">
                    Policy Updates
                  </a>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
